import {firebase} from "../config/firebase";

// //export const facebookProvider = new firebase.auth.FacebookAuthProvider();
// //export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const googleProvider = new firebase.auth.GoogleAuthProvider();